import { render, staticRenderFns } from "./TaskCreate.vue?vue&type=template&id=2483e61a&scoped=true&"
import script from "./TaskCreate.vue?vue&type=script&lang=js&"
export * from "./TaskCreate.vue?vue&type=script&lang=js&"
import style0 from "./TaskCreate.vue?vue&type=style&index=0&id=2483e61a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2483e61a",
  null
  
)

export default component.exports